import { Component, HostBinding, OnInit } from '@angular/core';
declare var $: any;

import { SettingsService } from './core/settings/settings.service';

import { environment } from '../environments/environment';

import { Adal4Service } from 'adal-angular4';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

const adalConfig = {
    tenant: environment.authentication.tenant,
    clientId: environment.authentication.clientId,
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/'
  };  

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.layout.isFixed; };
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.layout.isCollapsed; };
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.layout.isBoxed; };
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.layout.useFullLayout; };
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.layout.hiddenFooter; };
    @HostBinding('class.layout-h') get horizontal() { return this.settings.layout.horizontal; };
    @HostBinding('class.aside-float') get isFloat() { return this.settings.layout.isFloat; };
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.layout.offsidebarOpen; };
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.layout.asideToggled; };
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.layout.isCollapsedText; };

    constructor(private http: Http, public settings: SettingsService, private adalService: Adal4Service) {     

        //this.loadConfig();   
        
        this.adalService.init(adalConfig);
        this.adalService.handleWindowCallback();
    
        if (!this.adalService.userInfo.authenticated) {
            this.adalService.login();
        }

    }

    ngOnInit() {
        $(document).on('click', '[href="#"]', e => e.preventDefault());
    }

    loadConfig() {

        this.http.get('assets/env/config.json')
        .map(res => res.json())
        .toPromise()
        .then((envConfig) => {
 
            //console.log(envConfig);          

            adalConfig.clientId = envConfig.authentication.clientId;
            adalConfig.tenant = envConfig.authentication.tenant;
            
            //console.log(adalConfig);

            environment.endpoints.activityCommentRemovalApi = envConfig.endpoints.activityCommentRemovalApi;
            environment.endpoints.activityPostModerateApi = envConfig.endpoints.activityPostModerateApi;
            environment.endpoints.activityPostRemovalApi = envConfig.endpoints.activityPostRemovalApi;
            environment.authentication.clientId = envConfig.authentication.clientId;
            environment.authentication.tenant = envConfig.authentication.tenant;
            
            //console.log(environment); 
            
            this.adalService.init(adalConfig);
            this.adalService.handleWindowCallback();
    
            if (!this.adalService.userInfo.authenticated) {
                this.adalService.login();
            }
        });
    }  
}



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/app.component.ts